import {BitrixVue} from 'ui.vue3'
import store from 'ms.vuex_store'

import Button from './component/button';

export class FavoritesButton
{
	constructor(nodeId, productId, className) {
		this.rootNode = document.querySelector(nodeId)
		this.productId = productId
		this.className = className
	}

	init() {
		const context = this

		const application = BitrixVue.createApp({
			components: {
				Button
			},
			data() {
				return {
					productId: context.productId,
					className: context.className,
				}
			},
			created() {
				this.$store.dispatch('getUserFavorites')
			},
			template: '<Button :productId="productId" :className="className"/>'
		})
		application.use(store)
		application.mount(this.rootNode)
	}
}